<template>
  <v-row class="">
    <v-col
      cols="12"
      sm="3"
      class="d-flex"
      v-for="(card, index) in moduleCardInfo"
      :key="index"
    >
      <v-card
        elevation="8"
        height="100%"
        min-width="100%"
        style="min-height: 84px"
      >
        <v-row class="p-3">
          <v-col cols="8" class="pb-0">
            <div class="text-module">
              {{ card.name }}
            </div>
          </v-col>

          <v-col cols="6" class="pt-2">
            <p class="btn-config-module mb-0" @click="handleClickToConfig(card)">
              <span class="d-flex align-items-center" style="font-size: 12px">
                <img
                  src="/images/_SVGs/bo/seta-direita.svg"
                  onload="SVGInject(this)"
                  width="15"
                  height="15"
                />
                <span>{{ $t("backoffice.actions.config") }}</span>
              </span>
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    moduleCardInfo: Array | Object,
  },
  methods: {
    handleClickToConfig(card) {
        this.$router.push({ name: card.href });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
.text-module {
  font-size: 14px;
  padding-left: 1px !important;
}

.btn-config-module {
    justify-content: right;
    display: flex;
    align-items: center;
    float: left;
    cursor: pointer;
    span {
        font-size: 12px;
        color: var(--v-primary-base);

        svg {
            stroke: var(--v-primary-base) !important;
            path {
                fill: var(--v-primary-base) !important;
            }
        }
    }
    /* &:hover {
        span {
            font-size: 12px;
            color: var(--v-primary-base);

            svg path {
                fill: var(--v-primary-base) !important;
            }
        }
    } */
}
</style>
